import { useState } from 'react';

interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
    setMobileOpen(false);
  };

  const navLinks = [
    { label: '核心理念', id: 'philosophy' },
    { label: '系統架構', id: 'architecture' },
    { label: '運作流程', id: 'how-it-works' },
    { label: '報告樣本', id: 'sample' },
    { label: '常見問題', id: 'security-faq' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#050508]/95 backdrop-blur-md border-b border-[#00ffb4]/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div
          className="flex items-center space-x-3 cursor-pointer"
          onClick={() => scrollToSection('hero')}
        >
          <img
            src="https://static.readdy.ai/image/378dd0f6400ec53d43ae7d1d7dd92295/8acfdc25fd3b0de57798749a193ed73d.png"
            alt="TWINODE Logo"
            className="h-9 w-9 object-contain"
          />
          <span className="text-lg font-bold tracking-tight text-white">TWINODE</span>
          <span className="hidden sm:inline-block text-xs font-mono border border-[#00ffb4]/40 text-[#00ffb4] px-2 py-0.5 rounded-full">V4.0</span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="text-gray-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA */}
        <button
          onClick={() => scrollToSection('hero')}
          className="hidden md:block border border-[#00ffb4]/60 text-[#00ffb4] px-5 py-2 rounded-md text-xs font-bold hover:bg-[#00ffb4] hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          申請邀請碼
        </button>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#050508]/98 border-t border-[#00ffb4]/10 px-6 py-6 space-y-4">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="block w-full text-left text-gray-300 hover:text-white text-sm py-2 cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => scrollToSection('hero')}
            className="block w-full border border-[#00ffb4]/60 text-[#00ffb4] px-5 py-3 rounded-md text-sm font-bold text-center cursor-pointer"
          >
            申請邀請碼
          </button>
        </div>
      )}
    </nav>
  );
}
